  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
//import Link                                                from '@material-ui/core/Link';
//import Radio                                               from '@material-ui/core/Radio';
//import RadioGroup                                          from '@material-ui/core/RadioGroup';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
//import FormControl                                         from '@material-ui/core/FormControl';
//import Select                                              from '@material-ui/core/Select';
//import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
//import Typography                                          from '@material-ui/core/Typography';
  //--------------------
  // 3rd party libraries
  //--------------------
//import Cookies                                             from 'js-cookie';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_BillsService }                                 from "../../_services";
//import { wu_TransactionFlow }                              from "../../_services";
//import { wu_ProfileService }                               from "../../_services";
  //------
  // Style
  //------
  import BillsFavoritesDetailStyle                                from "./BillsFavoritesDetailStyle.jsx";
  //-------
  // images
  //-------
//import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";

  import Bills_Company_Placeholder                           from "assets/img/wu/Bills_Company_Placeholder.svg";

  import bills_repeatTrans_green                             from "assets/img/wu/bills_repeatTrans_green.png";
  import bills_editName_green                                from "assets/img/wu/bills_downloadReceipt_green.svg";
//import WU_FORM_add_plus_expand                             from "assets/img/wu/WU_FORM_add_plus_expand.svg";
  import WU_FORM_add_minus_retract                           from "assets/img/wu/WU_FORM_add_minus_retract.svg";
  //----------
  // variables
  //----------
  const filename = "BillsFavoritesDetail ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[Lockers]
  //var xxx_continue_locked = true;

class BillsFavoritesDetail extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      lbl_status                                             : "",
      imv_logo                                               : "",

      lbl_billsKeyVal01_isHidden                             : true,
      lbl_billsKeyVal02_isHidden                             : true,
      lbl_billsKeyVal03_isHidden                             : true,
      lbl_billsKeyVal04_isHidden                             : true,
      lbl_billsKeyVal05_isHidden                             : true,
      lbl_billsKeyVal06_isHidden                             : true,
      lbl_billsKeyVal07_isHidden                             : true,
      lbl_billsKeyVal08_isHidden                             : true,

      lbl_repeatTransaction                                  : "",
      lbl_editName                                           : "",
      lbl_removeFromFavorites                                : "",

      view_repeatTransaction_isHidden                        : true,
      view_editName_isHidden                                 : true,
      view_removeFromFavorites_isHidden                      : true,

      bills_repeatTrans                                      : bills_repeatTrans_green,
      imv_editName                                           : bills_editName_green,
      imv_removeFromFavorites                                : WU_FORM_add_minus_retract,

      //popup editFavorites
      dialog_editFavorites_msg                               : "",
      dialog_editFavorites_isOpen                            : false,
      textField10_text                                       : "",
      textField10_maxLength                                  : 50,
      textField10_type                                       : "text",
      textField10_hasError                                   : false,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                           = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                          = this.dialog_handleClose.bind(this);
    this.startSpinners                                               = this.startSpinners.bind(this);
    this.stopSpinners                                                = this.stopSpinners.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                        = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                       = this.dialog200_handleClose.bind(this);

    //[goBack]
    this.goBack                                                      = this.goBack.bind(this);

    //[SNACKBAR]for
    this.Snackbar_textField_handleOpen                               = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                              = this.Snackbar_textField_handleClose.bind(this);

    this.makeScreenTranslations                                      = this.makeScreenTranslations.bind(this);
    this.buildUI                                                     = this.buildUI.bind(this);
    this.makeHTTPConn                                                = this.makeHTTPConn.bind(this);
    this.process_CategoriesCompaniesObject                           = this.process_CategoriesCompaniesObject.bind(this);

    this.btn_repeatTransaction_act                                   = this.btn_repeatTransaction_act.bind(this);
    this.btn_editFavorites_act                                       = this.btn_editFavorites_act.bind(this);
    this.btn_removeFromFavorites_act                                 = this.btn_removeFromFavorites_act.bind(this);

    this.btn_done_act                                                = this.btn_done_act.bind(this);

    //popup editFavorites
    this.dialog_editFavorites_handleOpen                             = this.dialog_editFavorites_handleOpen.bind(this);
    this.dialog_editFavorites_btn_cancel                             = this.dialog_editFavorites_btn_cancel.bind(this);
    this.dialog_editFavorites_btn_add                                = this.dialog_editFavorites_btn_add.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view")); //f(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    localStorage.setItem("curr_view", filename);                          //if(api.print_logs){console.log(methName+localStorage.getItem("curr_view"));}

    //Do nothing if---get
    if(localStorage.getItem("prev_view").trim()==="xxx" ){
      if(api.print_logs){console.log("Do nothing if...");}
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){console.log(methName+"err="+JSON.stringify(err));}
      return;
    }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return;
    }
    //---------------------
    //newCustomer filtering--load Contoller---Exclude(LIGHT)
    //---------------------
    if(api.new_registration_enabled){
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
      if(customerLevel==="LIGHT"){ try {localStorage.setItem("newRegistrationFlow","newCustomer");   }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    //if(customerLevel==="BP")   { try {localStorage.setItem("newRegistrationFlow","upgradeAccount");}catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    }

    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    this.makeScreenTranslations();
    //-------------------------
    //wu_getCategoriesCompanies---CACHED
    //-------------------------
    let retrieveWSData_getCategoriesCompanies = wu_BillsService.wu_should_getCategoriesCompanies();
    if(api.print_logs){console.log("retrieveWSData_getCategoriesCompanies="+retrieveWSData_getCategoriesCompanies);}
    if(retrieveWSData_getCategoriesCompanies){
      wu_BillsService
      .wu_getCategoriesCompanies({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="BillsFavoritesDetail"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.process_CategoriesCompaniesObject();
        this.makeHTTPConn();
      })
      .catch(err => {
        console.log(methName+"err="+err);
      });
    }
    else{
      try{
        //let res = JSON.parse(localStorage.getItem("categoriescompanies"));
        this.process_CategoriesCompaniesObject();
        this.makeHTTPConn();
      }catch(err){
        console.log(methName+'err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn() {
    let methName = filename+"makeHTTPConn ";
    if(api.print_logs){console.log(methName);}

    var parserObject_bills_favoritelistDetail = null;
    try{ parserObject_bills_favoritelistDetail = JSON.parse(localStorage.getItem("parserObject_bills_favoritelistDetail"));}catch(err){console.log(methName+'err='+err);}
    //-----------------------------
    //wu_bills_BillsFavoritesDetail
    //-----------------------------
    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    wu_BillsService
    .wu_bills_billshistoryDetail({"transactionID":parserObject_bills_favoritelistDetail.transactionID})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="BillsFavoritesDetail"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_bills_billsHistoryDetail_res",JSON.stringify(res.paymentDetail));

      this.buildUI();
    })
    .catch(err => {
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){
        if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));}
        this.dialog_handleOpen(err.returnText);
      }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={api.columns_bills_sm} md={api.columns_bills_md}>

            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.BillsFavoritesDetail_lbl_status}>{this.state.lbl_status}</div>
              </GridItem>
              {this.state.imv_logo !== "" && this.state.imv_logo.indexOf(".png") > -1 ?
              <GridItem xs={2} sm={2} md={2}>
                <GridContainer justify="center">
                  <div className={classes.logo}><img src={this.state.imv_logo} alt="" /></div>
                </GridContainer>
              </GridItem>
              :
              (
              <GridItem xs={2} sm={2} md={2}>
                <GridContainer justify="center">
                  <div className={classes.companyIcon}><img src={Bills_Company_Placeholder} alt="companyIcon" /></div>
                </GridContainer>
              </GridItem>
              )}
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------[SUMMARY]------ */}
            {/* ------------------------- */}
            <div style={{ marginTop:10, marginBottom:20, "backgroundColor":"#EAEBED", padding:"0.8rem", "border-radius": "10px" }}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  {this.state.lbl_billsKeyVal01_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.NSInforString("BillsFavoritesDetail_lbl_Key01")}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal01}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal02_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.NSInforString("BillsFavoritesDetail_lbl_Key02")}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal02}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal03_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.NSInforString("BillsFavoritesDetail_lbl_Key03")}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal03}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal04_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.NSInforString("BillsFavoritesDetail_lbl_Key04")}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal04}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal05_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.NSInforString("BillsFavoritesDetail_lbl_Key05")}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal05}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal06_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.NSInforString("BillsFavoritesDetail_lbl_Key06")}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal06}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal07_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.NSInforString("BillsFavoritesDetail_lbl_Key07")}</div></GridItem>
                      <GridItem xs={7} sm={7} md={7}><div className={classes.viewRN_val}>{this.state.lbl_billsVal07}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_billsKeyVal08_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={5} sm={5} md={5}><div className={classes.viewRN_key}>{this.NSInforString("BillsFavoritesDetail_lbl_Key08")}</div></GridItem>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.lbl_billsVal08}</div></GridItem>
                    </GridContainer>
                  )}
                </GridItem>
              </GridContainer>
            </div>
            {/* -------------------------------- */}
            {/* ----------[PaymentMethod]------- */}
            {/* -------------------------------- */}
            <div style={{ marginTop:20, textAlign : "center"}}>
            <GridContainer justify="center">
              {this.state.view_repeatTransaction_isHidden === true ? ( "" ) : (
                <GridItem xs={4} sm={4} md={2}>
                  <Button onClick={this.btn_repeatTransaction_act}>
                  <div className={classes.PMTMImage}><img src={this.state.bills_repeatTrans} alt=""/></div>
                  </Button>
                  <div className={classes.PMTMLabel}>{this.state.lbl_repeatTransaction}</div>
                </GridItem>
              )}
              {this.state.view_editName_isHidden === true ? ( "" ) : (
                <GridItem xs={4} sm={4} md={2}>
                  <Button onClick={this.btn_editFavorites_act}>
                  <div className={classes.PMTMImage}><img src={this.state.imv_editName} alt=""/></div>
                  </Button>
                  <div className={classes.PMTMLabel}>{this.NSInforString("BillsFavoritesDetail_lbl_editName")}</div>
                </GridItem>
              )}
              {this.state.view_removeFromFavorites_isHidden === true ? ( "" ) : (
                <GridItem xs={4} sm={4} md={2}>
                  <Button onClick={this.btn_removeFromFavorites_act}>
                  <div className={classes.PMTMImage}><img src={this.state.imv_removeFromFavorites} alt=""/></div>
                  </Button>
                  <div className={classes.PMTMLabel}>{this.NSInforString("BillsFavoritesDetail_lbl_removeFromFavorites")}</div>
                </GridItem>
              )}
            </GridContainer>
            </div>
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* -------------------------------------------------- */}
            {/* ----------[goBack Bottom]------------------------- */}
            {/* -------------------------------------------------- */}
            {api.backButtonAtBottom === true ? (
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("BillsFavoritesDetail_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" ) }
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            {/* <GridContainer justify="center">
              <GridItem xs={10} sm={10} md={10}>
                <div className={classes.textCenter}>
                  <CustomButton
                    className={classes.yellowButton}
                    color="rose"
                    onClick={this.btn_done_act}
                    type="submit">
                    {this.NSInforString("BillsFavoritesDetail_btn_done")}
                  </CustomButton>
                </div>
              </GridItem>
            </GridContainer> */}

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* --------------------------------------- */}
        {/* ----------[POPUP editFavorites]-------- */}
        {/* --------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_editFavorites_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_editFavorites_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.NSInforString("BillsFavoritesDetail_viewFE_lbl_lb1")}</div></GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error={this.state.textField10_hasError}
                  className={classes.textField10}
                  id="textField10"
                  label={this.NSInforString("BillsFavoritesDetail_viewFE_lbl_plh01")}
                  value={this.state.textField10_text}
                  InputProps={{ onChange: event => this.change(event, "textField10_text"), type: this.state.textField10_type }}
                  inputProps={{maxLength: this.state.textField10_maxLength}}
                />
              </GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_editFavorites} color="default" onClick={this.dialog_editFavorites_btn_cancel}>{this.NSInforString("BillsFavoritesDetail_viewFE_btn_cancel")}</Button>
              <Button className={classes.popupOkButton_editFavorites} color="default" onClick={this.dialog_editFavorites_btn_add}>{this.NSInforString("BillsFavoritesDetail_viewFE_btn_save")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  makeScreenTranslations(){
      let methName = filename+"makeScreenTranslations ";
      if(api.print_logs){console.log(methName);}

      //Bills Fields
      let lbl_billsKeyVal01_isHidden=true; let lbl_billsKey01 = this.NSInforString("BillsFavoritesDetail_lbl_Key01"); let lbl_billsVal01 = "";
      let lbl_billsKeyVal02_isHidden=true; let lbl_billsKey02 = this.NSInforString("BillsFavoritesDetail_lbl_Key02"); let lbl_billsVal02 = "";
      let lbl_billsKeyVal03_isHidden=true; let lbl_billsKey03 = this.NSInforString("BillsFavoritesDetail_lbl_Key03"); let lbl_billsVal03 = "";
      let lbl_billsKeyVal04_isHidden=true; let lbl_billsKey04 = this.NSInforString("BillsFavoritesDetail_lbl_Key04"); let lbl_billsVal04 = "";
      let lbl_billsKeyVal05_isHidden=true; let lbl_billsKey05 = this.NSInforString("BillsFavoritesDetail_lbl_Key05"); let lbl_billsVal05 = "";
      let lbl_billsKeyVal06_isHidden=true; let lbl_billsKey06 = this.NSInforString("BillsFavoritesDetail_lbl_Key06"); let lbl_billsVal06 = "";
      let lbl_billsKeyVal07_isHidden=true; let lbl_billsKey07 = this.NSInforString("BillsFavoritesDetail_lbl_Key07"); let lbl_billsVal07 = "";
      let lbl_billsKeyVal08_isHidden=true; let lbl_billsKey08 = this.NSInforString("BillsFavoritesDetail_lbl_Key08"); let lbl_billsVal08 = "";

      this.setState({
        "lbl_billsKeyVal01_isHidden" : lbl_billsKeyVal01_isHidden,
        "lbl_billsKeyVal02_isHidden" : lbl_billsKeyVal02_isHidden,
        "lbl_billsKeyVal03_isHidden" : lbl_billsKeyVal03_isHidden,
        "lbl_billsKeyVal04_isHidden" : lbl_billsKeyVal04_isHidden,
        "lbl_billsKeyVal05_isHidden" : lbl_billsKeyVal05_isHidden,
        "lbl_billsKeyVal06_isHidden" : lbl_billsKeyVal06_isHidden,
        "lbl_billsKeyVal07_isHidden" : lbl_billsKeyVal07_isHidden,
        "lbl_billsKeyVal08_isHidden" : lbl_billsKeyVal08_isHidden,

        "lbl_billsKey01"             : lbl_billsKey01,
        "lbl_billsKey02"             : lbl_billsKey02,
        "lbl_billsKey03"             : lbl_billsKey03,
        "lbl_billsKey04"             : lbl_billsKey04,
        "lbl_billsKey05"             : lbl_billsKey05,
        "lbl_billsKey06"             : lbl_billsKey06,
        "lbl_billsKey07"             : lbl_billsKey07,
        "lbl_billsKey08"             : lbl_billsKey08,

        "lbl_billsVal01"             : lbl_billsVal01,
        "lbl_billsVal02"             : lbl_billsVal02,
        "lbl_billsVal03"             : lbl_billsVal03,
        "lbl_billsVal04"             : lbl_billsVal04,
        "lbl_billsVal05"             : lbl_billsVal05,
        "lbl_billsVal06"             : lbl_billsVal06,
        "lbl_billsVal07"             : lbl_billsVal07,
        "lbl_billsVal08"             : lbl_billsVal08,
      });
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  buildUI(){
      let methName = filename+"buildUI ";
      //if(api.print_logs){console.log(methName);}

      var parserObject_categoriesCompaniesList = null;
      try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

      var aItem1 = null;
      try{ aItem1 = JSON.parse(localStorage.getItem("parserObject_bills_favoritelistDetail"));}catch(err){console.log(methName+'err='+err);}

      var aItem = null;
      try{ aItem = JSON.parse(localStorage.getItem("parserObject_bills_billsHistoryDetail_res"));}catch(err){console.log(methName+'err='+err);}

      var ws_transId       = 0;
      var ws_billId        = 0;
      var ws_status        = 0;
      var ws_bpReason      = "";
      var ws_insDate       = "";
      var ws_amount        = 0.0;
      var ws_fees          = "";//Float(0.0);
      var ws_paymentCode   = "";
    //var ws_cardNum       = 0;
    //var ws_cardType      = "";
    //var ws_executionDate = "";
    //var ws_repeated      = false;
      var _companyName     = "";
      try {ws_transId       = aItem["transId"];       }catch(err){;} if(ws_transId       === null || (typeof ws_transId       ==="undefined")){ws_transId       = 0;}
      try {ws_billId        = aItem["billId"];        }catch(err){;} if(ws_billId        === null || (typeof ws_billId        ==="undefined")){ws_billId        = 0;}
      try {ws_status        = aItem["status"];        }catch(err){;} if(ws_status        === null || (typeof ws_status        ==="undefined")){ws_status        = 0;}
      try {ws_bpReason      = aItem["bpReason"];      }catch(err){;} if(ws_bpReason      === null || (typeof ws_bpReason      ==="undefined")){ws_bpReason      = "";}
      try {ws_insDate       = aItem["insDate"];       }catch(err){;} if(ws_insDate       === null || (typeof ws_insDate       ==="undefined")){ws_insDate       = "";}
      try {ws_amount        = aItem["amount"];        }catch(err){;} if(ws_amount        === null || (typeof ws_amount        ==="undefined")){ws_amount         = "";}
      try {ws_fees          = aItem["fees"];          }catch(err){;} if(ws_fees          === null || (typeof ws_fees          ==="undefined")){ws_fees          = "";}
      try {ws_paymentCode   = aItem["paymentCode"];   }catch(err){;} if(ws_paymentCode   === null || (typeof ws_paymentCode   ==="undefined")){ws_paymentCode   = "";}
    //try {ws_cardNum       = aItem["cardNum"];       }catch(err){;} if(ws_cardNum       === null || (typeof ws_cardNum       ==="undefined")){ws_cardNum       = 0;}
    //try {ws_cardType      = aItem["cardType"];      }catch(err){;} if(ws_cardType      === null || (typeof ws_cardType      ==="undefined")){ws_cardType      = "";}
    //try {ws_executionDate = aItem["executionDate"]; }catch(err){;} if(ws_executionDate === null || (typeof ws_executionDate ==="undefined")){ws_executionDate = "";}
    //try {ws_repeated      = aItem["repeated"];      }catch(err){;} if(ws_repeated      === null || (typeof ws_repeated      ==="undefined")){ws_repeated      = false;}
      try {_companyName     = aItem["_companyName"];  }catch(err){;} if(_companyName     === null || (typeof _companyName     ==="undefined")){_companyName     = "";}

      var companyObj = wu_Utilities.bills_companyObjectFromBillId(ws_billId,parserObject_categoriesCompaniesList);

      //var billsStatusText = "";
      //billsStatusText = wu_Utilities.bills_status_text(ws_status);

      // //nailed for testing:START-inactive
      // //ws_bpReason = "Αδυναμία συνδεσης με την τράπεζα του παρόχου. δοκιμάστε πάλι σε λίγο.";
      // //billsStatusText = "failure";
      // //nailed for testing:END
      //
      let lbl_status = aItem1.alias;
      // if(billsStatusText == "success"){ lbl_status.textColor = UIColor(red:  53/255, green: 182/255, blue:180/255, alpha: 1.0); }//35B6B4 (green)
      // if(billsStatusText == "failure"){ lbl_status.textColor = UIColor(red: 241/255, green:  13/255, blue: 13/255, alpha: 1.0); }//F10D0D (red)
      // if(billsStatusText == "pending"){ lbl_status.textColor = UIColor(red: 255/255, green: 147/255, blue: 30/255, alpha: 1.0); }//FF931E (orange)

      var imageURL = api.url + wu_Utilities.bills_images_urls(ws_billId,parserObject_categoriesCompaniesList);
      if(api.print_logs){console.log(methName+"imageURL="+imageURL);}

      //Bills Fields
      let lbl_billsKeyVal01_isHidden=false; let lbl_billsKey01 = this.NSInforString("BillsFavoritesDetail_lbl_Key01"); let lbl_billsVal01 = wu_Utilities.bills_companyNameFromBillId(ws_billId, parserObject_categoriesCompaniesList);
      let lbl_billsKeyVal02_isHidden=false; let lbl_billsKey02 = this.NSInforString("BillsFavoritesDetail_lbl_Key02"); let lbl_billsVal02 = ws_paymentCode;
      let lbl_billsKeyVal03_isHidden=false; let lbl_billsKey03 = this.NSInforString("BillsFavoritesDetail_lbl_Key03"); let lbl_billsVal03 = "EUR " + wu_Utilities.bills_normalizeAmount(ws_amount);
      let lbl_billsKeyVal04_isHidden=true;  let lbl_billsKey04 = this.NSInforString("BillsFavoritesDetail_lbl_Key04"); let lbl_billsVal04 = "";
      let lbl_billsKeyVal05_isHidden=true;  let lbl_billsKey05 = this.NSInforString("BillsFavoritesDetail_lbl_Key05"); let lbl_billsVal05 = "";
      let lbl_billsKeyVal06_isHidden=true;  let lbl_billsKey06 = this.NSInforString("BillsFavoritesDetail_lbl_Key06"); let lbl_billsVal06 = "";
      let lbl_billsKeyVal07_isHidden=true;  let lbl_billsKey07 = this.NSInforString("BillsFavoritesDetail_lbl_Key07"); let lbl_billsVal07 = "";
      let lbl_billsKeyVal08_isHidden=true;  let lbl_billsKey08 = this.NSInforString("BillsFavoritesDetail_lbl_Key08"); let lbl_billsVal08 = "";

      // view1.isHidden = false;
      // view1_constr_H.constant = (billsStatusText == "failure") ? CGFloat(7) * 40.0 : CGFloat(6) * 40.0;

      var lbl_repeatTransaction   = wu_Utilities.bills_isRepeatable(ws_billId,parserObject_categoriesCompaniesList) ? this.NSInforString("BillsFavoritesDetail_lbl_repeatTransaction") : this.NSInforString("BillsFavoritesDetail_lbl_repeatTransaction2");
      var lbl_editName            = this.NSInforString("BillsFavoritesDetail_lbl_editName");
      var lbl_removeFromFavorites = this.NSInforString("BillsFavoritesDetail_lbl_removeFromFavorites");

      var view_repeatTransaction_isHidden   = (api.bills_exclude_flags_enabled===true && wu_Utilities.bills_shouldBeInCategoriesListing(companyObj)===false) ? true : false;
      var view_editName_isHidden            = false;
      var view_removeFromFavorites_isHidden = wu_Utilities.bills_isTransactionFavorite_historyDetail(aItem) === true ? false : true;

      this.setState({
        "lbl_status"                 : lbl_status,
        "imv_logo"                   : imageURL,

        "lbl_billsKeyVal01_isHidden" : lbl_billsKeyVal01_isHidden,
        "lbl_billsKeyVal02_isHidden" : lbl_billsKeyVal02_isHidden,
        "lbl_billsKeyVal03_isHidden" : lbl_billsKeyVal03_isHidden,
        "lbl_billsKeyVal04_isHidden" : lbl_billsKeyVal04_isHidden,
        "lbl_billsKeyVal05_isHidden" : lbl_billsKeyVal05_isHidden,
        "lbl_billsKeyVal06_isHidden" : lbl_billsKeyVal06_isHidden,
        "lbl_billsKeyVal07_isHidden" : lbl_billsKeyVal07_isHidden,
        "lbl_billsKeyVal08_isHidden" : lbl_billsKeyVal08_isHidden,

        "lbl_billsKey01"             : lbl_billsKey01,
        "lbl_billsKey02"             : lbl_billsKey02,
        "lbl_billsKey03"             : lbl_billsKey03,
        "lbl_billsKey04"             : lbl_billsKey04,
        "lbl_billsKey05"             : lbl_billsKey05,
        "lbl_billsKey06"             : lbl_billsKey06,
        "lbl_billsKey07"             : lbl_billsKey07,
        "lbl_billsKey08"             : lbl_billsKey08,

        "lbl_billsVal01"             : lbl_billsVal01,
        "lbl_billsVal02"             : lbl_billsVal02,
        "lbl_billsVal03"             : lbl_billsVal03,
        "lbl_billsVal04"             : lbl_billsVal04,
        "lbl_billsVal05"             : lbl_billsVal05,
        "lbl_billsVal06"             : lbl_billsVal06,
        "lbl_billsVal07"             : lbl_billsVal07,
        "lbl_billsVal08"             : lbl_billsVal08,

        "lbl_repeatTransaction"      : lbl_repeatTransaction,
        "lbl_editName"               : lbl_editName,
        "lbl_removeFromFavorites"    : lbl_removeFromFavorites,

        "view_repeatTransaction_isHidden"   : view_repeatTransaction_isHidden,
        "view_editName_isHidden"            : view_editName_isHidden,
        "view_removeFromFavorites_isHidden" : view_removeFromFavorites_isHidden,
      });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------CheckBox Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------RadioButton Listeners-----------------------------
  //----------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Other Bank---------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_done_act(event) {
    let methName = filename+"btn_done_act ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    this.goBack(null);
  }
  //----------------------------------------------------------------------------------------------------
  btn_repeatTransaction_act(event) {
    let methName = filename+"btn_repeatTransaction_act ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    var parserObject_categoriesCompaniesList = null;
    try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

    var aItem = null;
    try{ aItem = JSON.parse(localStorage.getItem("parserObject_bills_billsHistoryDetail_res"));}catch(err){console.log(methName+'err='+err);}
    var ws_billId  = 0;
    var ws_transId = 0;
    try {ws_transId = aItem["transId"]; }catch(err){;} if(ws_transId === null || (typeof ws_transId ==="undefined")){ws_transId = 0;}
    try {ws_billId  = aItem["billId"];  }catch(err){;} if(ws_billId  === null || (typeof ws_billId  ==="undefined")){ws_billId  = 0;}

    var parserObject_bills_payment_info_billPayment_req = {};
    parserObject_bills_payment_info_billPayment_req["billerId"] = ws_billId;
    if(wu_Utilities.bills_isRepeatable(ws_billId,parserObject_categoriesCompaniesList)){ parserObject_bills_payment_info_billPayment_req["transactionId"] = ws_transId; }
    localStorage.setItem("parserObject_bills_payment_info_billPayment_req", JSON.stringify(parserObject_bills_payment_info_billPayment_req));
    localStorage.setItem("bills_billerId", ws_billId+"");

    localStorage.setItem("billPaymentSetup_ws","billPayment");
    //+++++++++++++++++
    //BillsPaymentSetup
    //+++++++++++++++++
    localStorage.setItem("BillsPaymentSetup_prev_view","BillsFavoritesDetail");
    history.push(wu_Utilities.getNavigationURLs("BillsPaymentSetup"));
  }
  //----------------------------------------------------------------------------------------------------
  btn_editFavorites_act(event) {
    let methName = filename+"btn_editFavorites_act ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    this.dialog_editFavorites_handleOpen(this.NSInforString("networkerror"),"NET");
  }
  //----------------------------------------------------------------------------------------------------
  btn_removeFromFavorites_act(event) {
    let methName = filename+"btn_removeFromFavorites_act ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    var aItem = null;
    try{ aItem = JSON.parse(localStorage.getItem("parserObject_bills_billsHistoryDetail_res"));}catch(err){console.log(methName+'err='+err);}

    //++++++++
    //Continue
    //++++++++
    //event.preventDefault();
    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    //this.startSpinners();
    setTimeout(function() { //Start the timer
      //------------------------
      //wu_bills_favorite_delete
      //------------------------
      wu_BillsService
      .wu_bills_favorite_delete({"transactionID":aItem.transId})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="BillsFavoritesDetail"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        if(res.returnCode===0){
          localStorage.setItem("triggerRefresh_Bills","true");          localStorage.setItem("triggerRefresh_Bills_LastDate", new Date());
          localStorage.setItem("triggerRefresh_BillsHistory","true");   localStorage.setItem("triggerRefresh_BillsHistory_LastDate", new Date());
          localStorage.setItem("triggerRefresh_BillsFavorites","true"); localStorage.setItem("triggerRefresh_BillsFavorites_LastDate", new Date());
          this.goBack(null);
        }
      })
      .catch(err => {
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        console.log(methName+"err="+JSON.stringify(err)+" err="+err);
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500)
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+event.target.value);}

    // if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
    //   this.setState({"textField0":eventTMP.trim(),});
    // }
    if(stateVar==="textField10_text"){
      //let fieldType = ""; try{ fieldType = this.state.parserObject_bills_payment_info_generic_res[0]["clientType"]; }catch (err){ ; }
      let fieldLength = 100;
      this.setState({ "textField10_hasError" : (eventTMP.trim() === "") ? true : false, "textField10_text":event.target.value+"" });
      //if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField10_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField10_hasError":true}); return; }
    }
    else{
      this.setState({ [stateVar] : event.target.value });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  NSInforString_withLang(aKey,lang){
    if(lang==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else           { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email"){ return wu_Utilities.wu_verifyEmail(val); }
    if(key==="MTCN") { return wu_Utilities.wu_verifyMTCN(val);  }

    return false;
  }
  importAll(r) {
    //return r.keys().map(r);
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
      return "";
    });
    return images;
  }
  //----------------------------------------------------------------------------------------------------
  comvert2ProperAmountFormat(amountStr){
    try{
      let parts = amountStr.split('.');
      let part1 = this.numberWithCommas(parts[0]);
      let part2 = parts[1];
      return part1+","+part2;
    }catch(err){;}
    return amountStr;
  }
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  //----------------------------------------------------------------------------------------------------
  process_CategoriesCompaniesObject(){
    let methName = filename+"process_CategoriesCompaniesObject ";
    if(api.print_logs){console.log(methName);}

    let categoryFieldDescr = localStorage.getItem("lang")==="el" ? "categoryEl" : "categoryEn";
    var parserObject_categoriesList = [];
    var parserObject_categoriesCompaniesList = null;
    try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

    for(var i=0; i<parserObject_categoriesCompaniesList.length; ++i){
       let aItem = parserObject_categoriesCompaniesList[i];
       let category   = "";
       var categoryEl = "";
       var categoryEn = "";
       var mid        = 0;
       try {category   = aItem[categoryFieldDescr]; }catch(err){;} if(category   === null || (typeof category   ==="undefined")){category   = "";}
       try {categoryEl = aItem["categoryEl"];       }catch(err){;} if(categoryEl === null || (typeof categoryEl ==="undefined")){categoryEl = "";}
       try {categoryEn = aItem["categoryEn"];       }catch(err){;} if(categoryEn === null || (typeof categoryEn ==="undefined")){categoryEn = "";}
       try {mid        = aItem["mid"];              }catch(err){;} if(mid        === null || (typeof mid        ==="undefined")){mid        = 0;}
       if(api.bills_exclude_flags_enabled===true && wu_Utilities.bills_shouldBeInCategoriesListing(aItem)===false){continue;}
       if(wu_Utilities.bills_categoryExists(category, parserObject_categoriesList) === false){
           let aCategory = {};
           aCategory["category"]   = category;
           aCategory["categoryEl"] = categoryEl;
           aCategory["categoryEn"] = categoryEn;
           aCategory["mid"]        = mid;
           parserObject_categoriesList.push(aCategory);
       }
    }

    parserObject_categoriesList.sort(function(a, b) {
      if( (a.category).localeCompare(b.category) === -1){ return -1; }
      if( (a.category).localeCompare(b.category) === 1){ return 1; }
      return 0;
    });

    var popularFound = false;
    for(var j=0; j<parserObject_categoriesCompaniesList.length; ++j){
       let aItem = parserObject_categoriesCompaniesList[j];
       if(api.bills_exclude_flags_enabled===true && wu_Utilities.bills_shouldBeInCategoriesListing(aItem)===false){continue;}
       var popularity = 0;
       try {popularity = aItem["popularity"]; }catch(err){;} if(popularity === null || (typeof popularity ==="undefined")){popularity = 0;}
       let category = this.NSInforString("Bills_popular_category");
       if(popularity > 0 && popularFound === false){
           let aCategory = {};
           aCategory["category"]   = category;
           aCategory["categoryEl"] = this.NSInforString_withLang("Bills_popular_category","el");
           aCategory["categoryEn"] = this.NSInforString_withLang("Bills_popular_category","en");
           aCategory["mid"]        = 1000000;
           parserObject_categoriesList.splice(0, 0, aCategory);//insert at index 0
           popularFound = true;
       }
    }

    this.setState({ "parserObject_categoriesList" : parserObject_categoriesList });
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  bills_status_friendlytext(status) {

           if(status === 82) { return this.NSInforString("Bills_status_code_success");  }
      else if(status === 83) { return this.NSInforString("Bills_status_code_success");  }
      else if(status === 84) { return this.NSInforString("Bills_status_code_canceled"); }
      else if(status === 90) { return this.NSInforString("Bills_status_code_failure");  }
      else if(status === 97) { return this.NSInforString("Bills_status_code_pending");  }
      else if(status === 89) { return this.NSInforString("Bills_status_code_pending");  }//24/07/2023

      return this.NSInforString("Bills_status_code_failure");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    let methName = filename+"goBack ";
    if(api.print_logs){console.log(methName);}

    if(api.print_logs){console.log(methName+"prev_view="+localStorage.getItem("prev_view").trim());}
    if(api.print_logs){console.log(methName+"navi_view="+localStorage.getItem("BillsFavoritesDetail_prev_view").trim());}
         if(localStorage.getItem("prev_view").trim()==="Bills")                { history.goBack();}
    else if(localStorage.getItem("prev_view").trim()==="BillsFavorites")       { history.goBack();}
    else{
      let zzz_prev_view = localStorage.getItem("BillsFavoritesDetail_prev_view");
      if(zzz_prev_view===null || (typeof zzz_prev_view==="undefined")){zzz_prev_view = "";}
      zzz_prev_view = zzz_prev_view.trim()
      localStorage.setItem("BillsFavoritesDetail_prev_view","");
           if(zzz_prev_view==="Bills")                { history.push(wu_Utilities.getNavigationURLs("Bills")); }
      else if(zzz_prev_view==="BillsFavorites")       { history.push(wu_Utilities.getNavigationURLs("BillsFavorites")); }
      else{
        //history.go(-1);
        history.goBack();
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups editFavorites------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_editFavorites_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_editFavorites_isOpen" : true,
        "dialog_editFavorites_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_editFavorites_btn_cancel(){
    this.setState({ "dialog_editFavorites_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  dialog_editFavorites_btn_add(){
    let methName = filename+"dialog_editFavorites_btn_add ";
    if(api.print_logs){console.log(methName);}

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.textField10_text === ""){ this.setState({"textField10_hasError":true}); emptyFields = true; }
      if(emptyFields===true){return;}
    }

    var aItem = null;
    try{ aItem = JSON.parse(localStorage.getItem("parserObject_bills_billsHistoryDetail_res"));}catch(err){console.log(methName+'err='+err);}

    this.setState({ "dialog_editFavorites_isOpen": false });
    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    //++++++++
    //Continue
    //++++++++
    //event.preventDefault();
    //this.startSpinners();
    setTimeout(function() { //Start the timer
      //------------------------
      //wu_bills_favorite_update
      //------------------------
      wu_BillsService
      .wu_bills_favorite_update({"transactionID":aItem.transId, "alias":this.state.textField10_text.trim()})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="BillsFavoritesDetail"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        if(res.returnCode===0){
          localStorage.setItem("triggerRefresh_Bills","true");          localStorage.setItem("triggerRefresh_Bills_LastDate", new Date());
          localStorage.setItem("triggerRefresh_BillsHistory","true");   localStorage.setItem("triggerRefresh_BillsHistory_LastDate", new Date());
          localStorage.setItem("triggerRefresh_BillsFavorites","true"); localStorage.setItem("triggerRefresh_BillsFavorites_LastDate", new Date());
          this.goBack(null);
        }
      })
      .catch(err => {
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        console.log(methName+"err="+JSON.stringify(err)+" err="+err);
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 1000)
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
}
BillsFavoritesDetail.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(BillsFavoritesDetailStyle)(BillsFavoritesDetail)
);
